import mapper from "./mapper"

export const userMapper = mapper

export default mapper
